import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/components/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/components/header.tsx");
